module.exports = __webpack_public_path__ + "static/logo-b86feeaf303b1605d10055a70cf8f897.svg";